import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { GoalRecapCard } from "web_myplann/Inspiration/Components/GoalRecapCard";
import { InspirationSheet } from "web_myplann/Inspiration/Components/InspirationSheet";
import type { InspirationGoalRecap } from "web_myplann/Inspiration/Types/InspirationTypes";

type Props = {
	open: boolean;
	recap: InspirationGoalRecap;
	onClose: () => void;
	onContinue: () => void;
};

export const InspirationGoalRecapSheet: FC<Props> = ({
	open,
	recap,
	onClose,
	onContinue,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<InspirationSheet
			open={open}
			onClose={onClose}
			title={recap.title}
			description={recap.description}
			primaryLabel={recap.continueLabel}
			onPrimary={onContinue}
			secondaryLabel={t(Resources.Common.Cancel)}
			onSecondary={onClose}
		>
			<GoalRecapCard rows={recap.rows} />

			<Typography variant="hint" color={theme.palette.grey[500]} relaxed>
				{recap.footnote}
			</Typography>
		</InspirationSheet>
	);
};
